<template>
    <div style="display: inline-block" >
        <el-select ref="inputPoped" v-model="territory_name" placeholder="请选择" @click.native="SelectPopedom"
                   @visible-change="false"
        >
        </el-select>
        <el-dialog :visible.sync="dialogVisible"
                   :modal-append-to-body='false'
                   :show-close="false"
                   width="500px"
                   id="dialog"
                   :before-close="handleClose"

        >

            <div style="text-align: center;height: 50px;position: relative;line-height: 50px; background: white;">
                <el-button
                        @click.native="clickBtnReturn" type="danger" size="small"
                        style="float: left;margin-top: 7px;position: absolute;left: 10px">
                    {{name}}
                </el-button>
                <span style="color: #3998f7;font-size: 18px;">请选择辖区</span>
                <el-button  type="success" size="small"
                            style="float: right;position: absolute;right: 10px;top: 10px"
                            @click.native="deterMine">确定
                </el-button>
            </div>
            <div v-if="isFalse">
                <div class="swiper-container" ref="swiperContainer"  style="margin: 10px 0 0 0" >
                    <div class="swiper-wrapper">

                        <div class="swiper-slide popedom_li" style="height:80px;display: flex;justify-content: space-between"
                             @click="select(item)"

                             :style="{backgroundColor:item.onoff?'#ECF3FC':'#fff',borderColor:item.onoff?'#4A90E2':'#ededed'}"
                             v-for="item in array">
                            <div style="padding: 10px 0 10px 10px">
                                <el-col style="font-size: 18px;height: 30px;">
                                <span style="font-size: 16px">
                                    {{item.territory_name}}
                                    &nbsp;
                                    ({{item.territory_code}})
                                </span>

                                </el-col>
                                <el-col style="color:#5898e3;font-size: 13px">
                                    <span>机构{{item.institution_num}}家</span>
                                    <el-divider direction="vertical" style="background: #5898e3"></el-divider>
                                    <span>门店{{item.retailstore_num}}家</span>
                                    <el-divider direction="vertical" style="background: #5898e3"></el-divider>
                                    <span>经销商{{item.distributor_num}}家</span>
                                </el-col>
                            </div>
                            <div style="height: 80px;line-height: 80px;padding:5px">
                                <img  style="width: 22px;height: 22px"
                                      :src="item.onoff?imgarr[1]:imgarr[0]" alt="">
                            </div>
                        </div>


                    </div>
                </div>
                <div style="height: 40px;width: 95%;padding: 0 10px;" >
                    <el-checkbox v-model="checked" @change="checkedClick"  style="height: 30px;color: #4BBFEF;float: left;">全选</el-checkbox>
                </div>
            </div>

            <span style="font-size: 16px;font-weight: bold;margin-left: 10px" v-if="!isstaff">或直接从辖区架构中选择管理辖区</span>
            <el-row style="height: 300px;overflow: auto;" v-if="!isstaff">
                <ul>
                    <li   class="popedom_li"
                          style="display: flex;height: 50px;justify-content: space-between;background: white;
                    align-items: center;border-bottom: 1px solid rgb(250,250,250)"
                          v-for="item in nextLevelArray" @click="changeNextLevel(item)">
                        <span style="font-size: 16px;margin-left: 10px">
                             {{item.territory_name}}
                                    &nbsp;
                             ({{item.territory_code}})
                        </span>
                        <div style="margin: 10px 10px 0 0">
                            <img style="width: 22px;height: 22px;"
                                 :src="item.onoff?imgarr[1]:imgarr[0]" alt="">
                            <img v-if="item.container_num > 0 ? true : false" style="width: 11px;height: 22px;margin-left: 10px;" :src="imgarr[2]" @click.stop="getTerritoryNextLevel(item)" >
                            <span v-else style="width: 12px;height: 20px;margin-left: 10px;display: inline-block"></span>
                        </div>
                    </li>
                </ul>
            </el-row>
            <el-row v-else style="width: 100%;height: 100px;">

            </el-row>
        </el-dialog>
    </div>
</template>

<script>
    import Swiper from 'swiper'
    import 'swiper/css/swiper.min.css'
    import 'swiper/js/swiper.min.js'
    import http from '../../APIService/http'
    export default {
        name: "popedom",
        props:{
            handleSelectInput:{
                type:Function,
                default:null
            }
        },
        data(){
            return{
                checked:false,
                isfalse:true,
                dialogVisible:false,
                imgarr:[require('../../assets/images/weixuan.png'),require('../../assets/images/gouxuan.png'),require('../../assets/images/next.png')],
                options:[],
                isSelect:true,
                array:[],
                nextLevelArray:[],
                territory_id : this.GLOBAL.territory_home_id ? this.GLOBAL.territory_home_id : [],
                territory_name : this.GLOBAL.territory_home_name ? this.GLOBAL.territory_home_name : '',
                copy_ter_id : {},    //记录点击辖区的id
                territoryInfo:'',
                item:{},
                isFalse:true,
                isstaff:this.$store.getters.getUser.role === 'staff',
                name:'关闭',
                infoObj:'',
                territoryArray :[]

            }
        },
        watch:{
            copy_ter_id:function (oldV,newV) {
                console.log(oldV)
                console.log(newV)
                console.log(this.array)
            }
        },
        created(){

            let user = this.$store.getters.getUser
            if(user.role == 'staff'){
                this.staffSelect()
            }else if(user.role == 'manager'){

                this.fun_select1('OWNER')
                this.fun_select('MANAGE')
            }else if(user.role == 'admin'){
                this.fun_select()
            }




        },
        methods:{
            handleClose(){

            },
            staffSelect(){
                let user = this.$store.getters.getUser
                let data = {
                    user_id : user.user_id,
                    tenant_id : user.tenant_id,
                    month : new Date()
                }
                http.post('/wapi/v1/getChildTerritoryList',data).then(res=>{
                    if (res.success){

                        this.array = res.data
                        
                        if(this.array.length>0){
                            if(this.GLOBAL.territory_home_id.length>0){
                                for(let i=0;i<this.array.length;i++){
                                    if(this.GLOBAL.territory_home_id.includes(this.array[i].territory_id)){
                                        this.array[i].onoff = true
                                    }
                                }
                            }else{
                                this.territory_id = []
                                this.array[0].onoff = true
                                this.territory_id.push(this.array[0].territory_id)
                                this.territory_name = this.array[0].territory_name +'（'+this.$store.getters.getUser.alias+'）'
                                this.GLOBAL.territory_home_id = this.territory_id
                                this.GLOBAL.territory_home_name = this.territory_name
                                this.handleSelectInput(this.territory_id)
                            }

                        }else{
                            this.isFalse = false
                        }


                    }
                })
            },
            async getTerritoryNextLevel(item){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                        territory_id:item.territory_id,
                        month : new Date()
                    }

                    await http.post('/wapi/v1/getSelectTerritoryList',data).then(res=>{
                        if (res.success){
                            this.territoryArray.push(item.territory_id)
                            this.nextLevelArray = res.data.array
                            this.infoObj = res.data.territory_id

                            this.nextLevelArray.forEach(item=>{
                                if(item.territory_id == this.territory_id[0]){
                                    item.onoff = true
                                }
                            })
                            if(this.territoryArray.length == 0){
                                this.name = '关闭'

                            }else{
                                this.name = '返回'
                            }
                            loading.close()
                        }
                    })

                } catch (e) {
                    loading.close()
                }
            },
            checkedClick(e){
                if(e == true){
                    this.territory_id = []
                    this.nextLevelArray.forEach(item=>{
                        item.onoff = false
                    })
                    this.array.forEach(item=>{
                        item.onoff = true
                        if(item.onoff == true){
                            if(this.territory_id.includes(item.territory_id)){
                            }else{
                                this.territory_id.push(item.territory_id)
                            }
                            if(this.territory_id.length == 1){
                                this.territory_name = item.territory_name + "（"+this.$store.getters.getUser.alias+"）"
                            }else{
                                this.territory_name = '多个辖区'+"（"+this.$store.getters.getUser.alias+"）"
                            }
                        }
                    })
                }else{
                    this.array.forEach(item=>{
                        item.onoff = false
                    })
                    this.territory_id = []
                    this.territory_name = ''
                }
            },
            async clickBtnReturn(){
                this.territoryArray.pop()
                if(this.name == '关闭'){
                    this.dialogVisible = false
                }else{
                    if(!this.infoObj){
                        this.name = '关闭'
                        const loading = this.$loading({
                            lock: true,
                            text: '拼命加载中',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        try {
                            let user = this.$store.getters.getUser
                            let type = ''
                            if(user.role == 'manger'){
                                type = 'MANAGE'
                            }
                            let data = {
                                user_id : user.user_id,
                                tenant_id : user.tenant_id,
                                territory_id:this.infoObj,
                                type:type,
                                month : new Date()
                            }

                            await http.post('/wapi/v1/getSelectTerritoryList',data).then(res=>{
                                if (res.success){

                                    this.nextLevelArray = res.data.array
                                    this.infoObj = res.data.territory_id
                                    this.nextLevelArray.forEach(item=>{
                                        if(item.territory_id == this.territory_id[0]){
                                            item.onoff = true
                                        }
                                    })
                                    loading.close()
                                }
                            })

                        } catch (e) {
                            loading.close()
                        }
                    }
                    else{
                        this.name = '返回'

                        const loading = this.$loading({
                            lock: true,
                            text: '拼命加载中',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        try {
                            let user = this.$store.getters.getUser
                            let type = ''
                            if(user.role == 'manger'){
                                type = 'MANAGE'
                            }
                            let data = {
                                user_id : user.user_id,
                                tenant_id : user.tenant_id,
                                territory_id:this.infoObj,
                                type:type,
                                month : new Date()
                            }

                            await http.post('/wapi/v1/getSelectTerritoryList',data).then(res=>{
                                if (res.success){

                                    this.nextLevelArray = res.data.array
                                    this.infoObj = res.data.territory_id
                                    this.nextLevelArray.forEach(item=>{
                                        if(item.territory_id == this.territory_id[0]){
                                            item.onoff = true
                                        }
                                    })
                                    loading.close()
                                }
                            })

                        } catch (e) {
                            loading.close()
                        }
                    }
                }





            },
            SelectPopedom(){


                this.$refs.inputPoped.blur()
                this.dialogVisible=true
                this.$nextTick(
                    ()=>{
                        new Swiper(".swiper-container", {
                            observer:true,
                            observeParents:true
                        });
                    }
                )
            },
            async fun_select(type){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                        territory_id:'',
                        type : type,
                        month : new Date()
                    }

                    await http.post('/wapi/v1/getSelectTerritoryList',data).then(res=>{
                        if (res.success){

                            this.nextLevelArray = res.data.array


                            if(this.nextLevelArray.length>0 ){
                                if(this.GLOBAL.territory_home_id.length>0){
                                    for(let i=0;i<this.nextLevelArray.length;i++){
                                        if(this.GLOBAL.territory_home_id.includes(this.nextLevelArray[i].territory_id)){
                                            this.nextLevelArray[i].onoff = true
                                        }
                                    }
                                }else{
                                    this.territory_id = []
                                    this.nextLevelArray[0].onoff = true
                                    this.territory_id.push(this.nextLevelArray[0].territory_id)
                                    this.territory_name = this.nextLevelArray[0].territory_name +'（'+this.$store.getters.getUser.alias+'）'
                                    this.GLOBAL.territory_home_id = this.territory_id
                                    this.GLOBAL.territory_home_name = this.territory_name
                                    this.handleSelectInput(this.territory_id)
                                }

                            }
                            if(this.array.length == 0){
                                this.isFalse = false
                            }else{
                                this.isFalse = true
                            }


                            loading.close()

                        }
                    })

                } catch (e) {
                    loading.close()

                }
            },
            async fun_select1(type){
                const loading1 = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                        territory_id:'',
                        type : type,
                        month : new Date()
                    }

                    await http.post('/wapi/v1/getSelectTerritoryList',data).then(res=>{
                        if (res.success){

                            this.array = res.data.array
                            if(this.array.length>0){
                                if(this.GLOBAL.territory_home_id.length>0){
                                    for(let i=0;i<this.array.length;i++){
                                        if(this.GLOBAL.territory_home_id.includes(this.array[i].territory_id)){
                                            this.array[i].onoff = true
                                        }
                                    }
                                    if(this.GLOBAL.territory_home_id.length == this.array.length){
                                        this.checked = true
                                    }
                                }else{
                                    this.territory_id = []
                                    this.array[0].onoff = true
                                    this.territory_id.push(this.array[0].territory_id)
                                    this.territory_name = this.array[0].territory_name +'（'+this.$store.getters.getUser.alias+'）'
                                    this.GLOBAL.territory_home_id = this.territory_id
                                    this.GLOBAL.territory_home_name = this.territory_name
                                    this.handleSelectInput(this.territory_id)
                                }
                            }else{
                                this.isFalse = false
                            }

                            loading1.close()

                        }
                    })

                } catch (e) {
                    loading1.close()
                }
            },

            select(item){
                let off = false

                this.nextLevelArray.forEach((item)=>{
                    item.onoff = false
                })


                item.onoff = !item.onoff
                this.territory_id = []
                this.array.forEach(item=>{
                    if(item.onoff == true){
                        if(this.territory_id.includes(item.territory_id)){

                        }else{
                            this.territory_id.push(item.territory_id)
                        }
                        if(this.territory_id.length == 1){
                            this.territory_name = item.territory_name + "（"+this.$store.getters.getUser.alias+"）"
                        }else{
                            this.territory_name = '多个辖区'+"（"+this.$store.getters.getUser.alias+"）"
                        }
                        off = true

                    }else{
                        this.checked = false
                        off = false
                    }
                })
                if(off == false){
                    this.checked = false
                }else{
                    if(this.territory_id.length == this.array.length){
                        this.checked = true
                    }

                }

                // this.item = item
                this.$forceUpdate()
            },

            changeNextLevel(item){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    this.checked = false

                    if(item.onoff == true){
                        let user = this.$store.getters.getUser
                        let data = {
                            user_id : user.user_id,
                            tenant_id : user.tenant_id,
                            territory_id:'',
                            type : 'OWNER',
                            month : new Date()
                        }

                        http.post('/wapi/v1/getSelectTerritoryList',data).then(res=>{
                            if (res.success){
                                this.array = res.data.array
                                this.array.forEach((item)=>{
                                    item.onoff = false
                                })
                                this.nextLevelArray.forEach((item)=>{
                                    item.onoff = false
                                })
                                this.territory_id = []
                                this.territory_name = ''

                                if(this.array.length == 0){
                                    this.isFalse = false
                                }else{
                                    this.isFalse = true
                                }
                            }
                            this.$forceUpdate()
                            loading.close()

                        })


                    }else{
                        let user = this.$store.getters.getUser
                        let data = {
                            user_id : user.user_id,
                            tenant_id : user.tenant_id,
                            territory_id:item.territory_id,
                            month : new Date(),

                        }
                        http.post('/wapi/v1/getChildTerritoryList',data).then(res=>{
                            if(res.success){
                                this.array = res.data
                                this.array.forEach((item)=>{
                                    item.onoff = false
                                })
                                this.nextLevelArray.forEach((item)=>{
                                    item.onoff = false
                                })
                                item.onoff = !item.onoff
                                this.territory_id = []
                                this.territory_id.push(item.territory_id)
                                this.territory_name = item.territory_name + "（"+this.$store.getters.getUser.alias+"）"


                                if(this.array.length == 0){
                                    this.isFalse = false
                                }else{
                                    this.isFalse = true
                                }

                                this.$forceUpdate()
                                loading.close()
                            }
                        })


                    }

                }catch (e) {
                    loading.close()
                }



            },

            deterMine(){

                if(this.territory_id.length>0){
                    this.GLOBAL.territory_home_id = this.territory_id
                    this.GLOBAL.territory_home_name = this.territory_name
                    this.handleSelectInput(this.territory_id)
                    this.dialogVisible = false
                }else{
                    this.$message({
                        type:'error',
                        message:'请至少选择一个辖区'
                    })
                }

            },
        },

        mounted() {
        }
    }
</script>

<style >
    #dialog .el-dialog__body{
        background: #f6f7fa;
        padding: 0px 0!important;
    }
    #dialog .el-dialog__header{
        padding: 0px 0!important;
    }
    #dialog .swiper-container{
        height: 90px;
        display: flex;

    }
    #dialog .swiper-wrapper{
        height: 90px;
    }
    #dialog .swiper-slide{
        width: 300px!important;
        margin-left: 10px;
        background-color: #fff;
        border: 1px solid #ededed;
    }
    .el-divider--vertical{
        background: #5898e3!important;
        width: 2px!important;
        margin: -1px 8px 0px;
    }
    #dialog .popedom_li:hover{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/pages/home/homepopedom.vue